// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "66355b38acf5160951f76593d0c771a3ae274a69/static/css/" + chunkId + "." + {"252":"3d0d1673","725":"84c1fc5e","854":"36854e5e"}[chunkId] + ".chunk.css";
};